import { render } from "./HeroAuthConferenceDashboard.vue?vue&type=template&id=666d8f80&scoped=true"
import script from "./HeroAuthConferenceDashboard.vue?vue&type=script&lang=js"
export * from "./HeroAuthConferenceDashboard.vue?vue&type=script&lang=js"

import "./HeroAuthConferenceDashboard.vue?vue&type=style&index=0&id=666d8f80&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-666d8f80"]])

export default __exports__